module.exports = __webpack_public_path__ + "img/climate-control-ac.5a415336.png";